import { AuthRepository } from "@/domain/repository/auth-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class ExchangeAESKeyUsecase {
  constructor(private readonly authRepo: AuthRepository) {}

  async execute(): Promise<SATResult<void, SATError>> {
    const result = await this.authRepo.exchangeAndSaveAESecretKeyByCookie();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
